@if(selectedUserRole !== UserRoles.SuperAdmin){
<div class="w-full flex flex-col mt-2 gap-4 pt-5">
    <h6 class="text-sm text-zen font-medium text-center">{{"Employee Experience Products Permission"| translate:
        language:ModuleNames.Common}} *</h6>

    <div class="flex flex-row items-start">
        <div class="flex flex-col  w-1/3 text-xs text-zen font-medium pb-3">
            <input class="leading-10 max-h-10 rounded-lg px-5" (input)="filterPermission($event.target.value)"
                [placeholder]="'txt_companies'| translate: language:ModuleNames.Common" />
            <div class="flex max-w-xs overflow-scroll">
                <mat-tree #tree [dataSource]="permissionDataSource" [treeControl]="permissionTreeControl"
                    class="permission-tree1 bg-transparent overflow-scroll">
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                        <div class="flex flex-row w-full divide-x maxMin10 items-center justify-between hover:bg-exp hover:bg-opacity-5 width-fit"
                            [ngClass]="node.highlight?'bg-exp bg-opacity-5':''">
                            <div class="flex flex-col justify-center h-10">
                                <div class="flex flex-row items-center text-xs text-zen w-40">
                                    <button class="w-8 flex-none invisible" disabled><i
                                            class="fa-regular fa-chevron-down"></i></button>
                                    <div class="flex flex-row items-center btn text-xs text-zen"
                                        (click)="handleClickAll(node.key)">
                                        <i [ngClass]="getCompanyPermission(node.key)?.products?.length == products?.length ? 'text-exp fa-square-check font-semibold': getCompanyPermission(node.key)?.products?.length?'text-exp fa-square-check':'fa-square'"
                                            class="fa-regular text-lg"></i>
                                        <h5 class="whitespace-nowrap px-3">{{node.name| extract: language}}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tree-node>
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                        <div>
                            <div class="flex flex-row w-full divide-x maxMin10 items-center justify-between hover:bg-exp hover:bg-opacity-5 width-fit"
                                [ngClass]="node.highlight?'bg-exp bg-opacity-5':''">
                                <div class="flex flex-col  justify-center ">
                                    <div class="flex flex-row items-center text-xs text-zen w-40">
                                        <button class="w-8 flex-none" matTreeNodeToggle
                                            [attr.aria-label]="'Toggle ' +node.name| extract: language">
                                            <i class="fa-regular"
                                                [ngClass]="permissionTreeControl.isExpanded(node)?'fa-chevron-down':(language|language)?'fa-chevron-left': 'fa-chevron-right'"></i>

                                        </button>
                                        <div class="flex flex-row items-center btn text-xs text-zen"
                                            (click)="handleClickAll(node.key);handleClickAllNested(node.key)">
                                            <i [ngClass]="getCompanyPermission(node.key)?.products?.length == products?.length ? 'text-exp fa-square-check font-semibold': getCompanyPermission(node.key)?.products?.length?'text-exp fa-square-check':'fa-square'"
                                                class="fa-regular text-lg"></i>
                                            <h5 class="whitespace-nowrap px-3">{{node.name| extract: language}}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div [class.permission-tree-invisible]="!permissionTreeControl.isExpanded(node)" role="group">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                    </mat-nested-tree-node>
                </mat-tree>
            </div>
        </div>
        <div class="flex flex-col w-2/3 overflow-scroll">
            <div class="flex flex-row divide-x items-center ">
                <div class="flex flex-col  maxw20	max-h-10  pb-3" *ngFor="let product of products">
                    @let productName = (product == "360"?'txt360180_Feedback':product)| translate:language:ModuleNames.Common;
                    <img *ngIf="isProduct(product)" [src]="getProductIcon(product)" alt="" class="max-h-10"
                        [matTooltip]="productName">
                    <span class="text-xs text-center text-zen" *ngIf="!isProduct(product)">{{productName| uppercase}}</span>
                </div>
            </div>
            <mat-tree #tree [dataSource]="permissionDataSource" [treeControl]="permissionTreeControl"
                class="permission-tree bg-transparent">
                <mat-tree-node class="h-10" *matTreeNodeDef="let node" matTreeNodeToggle>
                    <div class="flex flex-row w-full divide-x maxMin10 items-center justify-between hover:bg-exp hover:bg-opacity-5 width-fit"
                        [ngClass]="node.highlight?'bg-exp bg-opacity-5':''">
                        <div class="flex flex-row divide-x items-center">
                            <div class="flex flex-row h-10 items-center w-20 justify-center btn"
                                *ngFor="let product of products" (click)="permissionHandle(product, node.key)">
                                <i class="fa-regular btn w-9 text-center text-lg"
                                    [ngClass]="permissionCheck(product, node.key)?'text-exp fa-square-check font-semibold':'text-zen fa-square'"></i>
                            </div>
                        </div>
                    </div>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div class="flex flex-row w-full divide-x maxMin10 items-center justify-between hover:bg-exp hover:bg-opacity-5 width-fit"
                        [ngClass]="node.highlight?'bg-exp bg-opacity-5':''">

                        <div class="flex flex-col">
                            <div class="flex flex-row divide-x items-center">
                                <div (click)="permissionHandle(product, node.key); permissionHandleNested(product, node.key);"
                                    class="flex flex-row h-10 items-center w-20 justify-center btn"
                                    *ngFor="let product of products">
                                    <i class="fa-regular w-9 text-center text-lg"
                                        [ngClass]="permissionCheck(product, node.key)?'text-exp fa-square-check font-semibold':'text-zen fa-square'"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div [class.permission-tree-invisible]="!permissionTreeControl.isExpanded(node)" role="group">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>

                </mat-nested-tree-node>
            </mat-tree>
        </div>
    </div>
</div>
}